<app-unique-general-filters [filter]="filter" (favouriteEndgameContentChanged)="onFavouriteEndgameContentChanged()"></app-unique-general-filters>

<div class="filter-group" data-group-visibility-id="showValuableUniquesFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showValuableUniquesFilters" (click)="filter.groupVisibility.showValuableUniquesFilters = !filter.groupVisibility.showValuableUniquesFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Valuable Uniques" [activeRules]="activeSpecialRules.valuableUniqueFilters">
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showValuableUniquesFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showValuableUniquesFilters">

      <div class="filter filter-property full-span">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.uniqueTierCosmetics[0].displayOptions.active" (click)="toggleHighlightExcellentUniques()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Excellent Uniques" [additionalContent]="excellentUniquesStylePreview" [ruleIds]="['uniques-excellent', 'uniques-potential']"
            [class.disabled]="!filter.uniqueTierCosmetics[0].displayOptions.active">
            <app-content cid="potential-uniques" contentType="tip"></app-content>
            <ng-template #excellentUniquesStylePreview>
              <app-style-picker
                [displayable]="filter.uniqueTierCosmetics[0]"
                [allowHide]="false"
                [forceHidden]="!filter.uniqueTierCosmetics[0].displayOptions.active && filter.hideAllRemainingUniques"
                [defaultVisible]="!filter.hideAllRemainingUniques"
                [defaultHidden]="filter.hideAllRemainingUniques"
                [exampleName]="firstExcellentUnique"
                [rarity]="Rarity.Unique"
                [title]="'Excellent Uniques'"></app-style-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="uniques-good"
            [class.disabled]="!filter.uniqueTierCosmetics[1].displayOptions.active">
            <span class="input-group-btn">
              <button class="btn toggle-btn"
                [disabled]="!filter.uniqueTierCosmetics[0].displayOptions.active"
                [class.off]="!filter.uniqueTierCosmetics[1].displayOptions.active"
                (click)="toggleHighlightGoodUniques()"></button>
            </span>
            <div class="table-checkbox-label">
              <span class="filter-title-text">
                {{ isMobile() ? 'Good' : 'Good Uniques' }}
              </span>

              <app-style-picker
                [displayable]="filter.uniqueTierCosmetics[1]"
                [allowHide]="false"
                [forceHidden]="!filter.uniqueTierCosmetics[1].displayOptions.active && filter.hideAllRemainingUniques"
                [defaultVisible]="!filter.hideAllRemainingUniques"
                [defaultHidden]="filter.hideAllRemainingUniques"
                [exampleName]="firstGoodUnique"
                [rarity]="Rarity.Unique"
                [title]="'Good Uniques'"></app-style-picker>
            </div>
          </div>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="uniques-potential"
            [class.disabled]="!filter.uniqueTierCosmetics[2].displayOptions.active">
            <span class="input-group-btn">
              <button class="btn toggle-btn"
                [disabled]="!filter.uniqueTierCosmetics[0].displayOptions.active"
                [class.off]="!filter.uniqueTierCosmetics[2].displayOptions.active"
                (click)="toggleHighlightPotentialUniques()"></button>
            </span>
            <div class="table-checkbox-label">
              <span class="filter-title-text">
                {{ isMobile() ? 'Potential' : 'Potential Uniques' }}
              </span>

              <app-style-picker
                [displayable]="filter.uniqueTierCosmetics[2]"
                [allowHide]="false"
                [forceHidden]="!filter.uniqueTierCosmetics[2].displayOptions.active && filter.hideAllRemainingUniques"
                [defaultVisible]="!filter.hideAllRemainingUniques"
                [defaultHidden]="filter.hideAllRemainingUniques"
                [exampleName]="firstPotentialUnique"
                [rarity]="Rarity.Unique"
                [title]="'Potential Uniques'"></app-style-picker>
            </div>
          </div>
        </span>
      </div>

      <div class="filter filter-property full-span">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [disabled]="!filter.uniqueTierCosmetics[0].displayOptions.active"
            [class.off]="!filter.uniqueTierCosmetics[3].displayOptions.active"
            (click)="toggleHighlightRestrictedUniques()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Restricted Uniques" [additionalContent]="restrictedUniquesStylePreview" ruleId="uniques-restricted"
            [class.disabled]="!filter.uniqueTierCosmetics[3].displayOptions.active">
            You can safely disable and even hide these when you are running regular maps. Be sure to enable this when doing various bosses or special content.
            <br /><br />If you frequently do certain bosses or special content, select these as your 'Favourite Endgame Content' in the General section or on the Presets tab. This prevents those restricted uniques from getting hidden.
            <ng-template #restrictedUniquesStylePreview>
              <app-style-picker
                [displayable]="filter.uniqueTierCosmetics[3]"
                [allowHide]="false"
                [forceHidden]="!filter.uniqueTierCosmetics[3].displayOptions.active && filter.hideAllRemainingUniques"
                [defaultVisible]="!filter.hideAllRemainingUniques"
                [defaultHidden]="filter.hideAllRemainingUniques"
                [exampleName]="firstRestrictedUnique"
                [rarity]="Rarity.Unique"
                [title]="'Restricted Uniques'"></app-style-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="uniques-restricted-favourite-bosses"
            [class.disabled-filter-property-container]="!isSpecificEndgameContentSelected || filter.uniqueTierCosmetics[3].displayOptions.active">
            <span class="input-group-btn">
              <button class="btn toggle-btn"
                [disabled]="filter.uniqueTierCosmetics[3].displayOptions.active"
                [class.off]="!filter.showFavouriteRestrictedBossUniques"
                (click)="toggleShowFavouriteRestrictedBossUniques()"></button>
            </span>
            <div class="table-checkbox-label">
              <span class="filter-title-text">Favourite Restricted Uniques</span>
            </div>

            @if (!isSpecificEndgameContentSelected) {
              <div class="disabled-filter-property inline" (click)="navigateToFavouriteRestrictedBossUniques()">
                Requires <strong>Favourite Content</strong>.
              </div>
            } @else if (filter.uniqueTierCosmetics[3].displayOptions.active) {
              <div class="disabled-filter-property inline" (click)="navigateToRestrictedUniques()">
                <strong>Restricted Uniques</strong> is enabled.
              </div>
            }
          </div>
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>

<div class="filter-group" data-group-visibility-id="showSpecialUniquesFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showSpecialUniquesFilters" (click)="filter.groupVisibility.showSpecialUniquesFilters = !filter.groupVisibility.showSpecialUniquesFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Special Uniques" [activeRules]="activeRules.specialUniqueFilters">
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showSpecialUniquesFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showSpecialUniquesFilters">

      @if (poe2) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showExceptionalUniques">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="!filter.showExceptionalUniques"
              (click)="toggleHighlightExceptionalOtherUniques()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Exceptional Uniques" [additionalContent]="exceptionalUniquesStylePreview" ruleId="uniques-exceptional">
              <ng-template #exceptionalUniquesStylePreview>
                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showExceptionalUniques === true"
                  [defaultHidden]="filter.hideAllRemainingUniques"
                  ruleId="uniques-exceptional"
                  [exampleName]="'Exceptional Wrapped Sandals'"
                  [rarity]="Rarity.Unique"
                  [title]="'Exceptional Uniques'"></app-custom-rule-style-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Min Quality
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="qual" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showExceptionalUniques"
              [(ngModel)]="filter.showExceptionalUniquesMinQuality" (change)="updateFilter()">
          </span>
        </div>

        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showVaalModUniques" (click)="toggleHighlightVaalModUniques()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Vaal Mod Uniques" [additionalContent]="vaalModUniquesStylePreview" ruleId="uniques-vaal-mod"
              [class.disabled]="!filter.showVaalModUniques">
              <ng-template #vaalModUniquesStylePreview>
                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showVaalModUniques"
                  [defaultHidden]="filter.hideAllRemainingUniques"
                  ruleId="uniques-vaal-mod"
                  [exampleName]="'Vaal Mod Unique'"
                  [rarity]="Rarity.Unique"
                  [title]="'Vaal Mod Uniques'"></app-custom-rule-style-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="uniques-vaal"
              [class.disabled]="!filter.showVaalUniques">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="!filter.showVaalUniques"
                  (click)="toggleHighlightVaalUniques()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">
                  {{ isMobile() ? 'Vaal' : 'Vaal Uniques' }}
                </span>

                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showVaalUniques"
                  [defaultHidden]="filter.hideAllRemainingUniques"
                  ruleId="uniques-vaal"
                  [exampleName]="'Vaal Unique'"
                  [rarity]="Rarity.Unique"
                  [title]="'Vaal Uniques'"></app-custom-rule-style-picker>
              </div>
            </div>
          </span>
        </div>
      }

      @if (poe1) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showFoulbornUniques">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showFoulbornUniques" (click)="toggleHighlightFoulbornUniques()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Foulborn Uniques" [additionalContent]="foulbornUniquesStylePreview" ruleId="uniques-foulborn">
              <ng-template #foulbornUniquesStylePreview>
                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showFoulbornUniques"
                  [defaultHidden]="filter.hideAllRemainingUniques"
                  ruleId="uniques-foulborn"
                  [exampleName]="'Foulborn Unique'"
                  [rarity]="Rarity.Unique"
                  [title]="'Foulborn Uniques'"></app-custom-rule-style-picker>
              </ng-template>
            </span>
          </span>
        </div>

        <div class="filter filter-property full-span" [class.disabled]="!filter.showUniqueMaps">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showUniqueMaps" (click)="toggleHighlightUniqueMaps()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Unique Maps" [additionalContent]="uniqueMapsStylePreview" ruleId="uniques-maps">
              Highlights unique maps. Since v3.28, it is no longer possible to tell Unique Maps apart since they all share the same Base Type. <strong>Disabling this will hide all Unique Maps.</strong>
              <ng-template #uniqueMapsStylePreview>
                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showUniqueMaps"
                  [defaultHidden]="true"
                  ruleId="uniques-maps"
                  [exampleName]="'Map (Tier 16)'"
                  [rarity]="Rarity.Unique"
                  [title]="'Unique Maps'"></app-custom-rule-style-picker>
              </ng-template>
            </span>
          </span>
        </div>

        <div class="filter filter-property full-span" [class.disabled]="!filter.showHighDustValueUniques">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showHighDustValueUniques" (click)="toggleHighlightHighDustValueUniques()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Disenchant Uniques" [additionalContent]="highDustValueUniquesStylePreview" ruleId="uniques-high-dust">
              Highlights good candidates to disenchant: non-valuable (Other and Potential) <span class="uniques-color">Uniques</span> whose (non-restricted) Thaumaturgic Dust values meet the Avg and Min thresholds (ilvl 84, 0 quality).
              <br /><br /><strong>Jewellery</strong>: {{ highDustJewelleryBaseTypes.length ? highDustJewelleryBaseTypes.join(', ') : 'None' }}
              <br /><strong>Non-jewellery</strong>: {{ !filter.showHighDustValueUniquesIncludeNonJewellery ? 'Disabled' : (highDustNonJewelleryBaseTypes.length ? highDustNonJewelleryBaseTypes.join(', ') : 'None') }}
              <ng-template #highDustValueUniquesStylePreview>
                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showHighDustValueUniques"
                  [defaultHidden]="filter.hideAllRemainingUniques"
                  ruleId="uniques-high-dust"
                  [exampleName]="highDustJewelleryBaseTypes[0] || highDustNonJewelleryBaseTypes[0] || 'Unique'"
                  [rarity]="Rarity.Unique"
                  [title]="'Disenchant Uniques'"></app-custom-rule-style-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Avg
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="avg" maxlength="6" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showHighDustValueUniques"
              [(ngModel)]="filter.showHighDustValueUniquesMinAverage" (change)="rebuildTierList()">
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Min
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="min" maxlength="6" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showHighDustValueUniques"
              [(ngModel)]="filter.showHighDustValueUniquesMinDust" (change)="rebuildTierList()">
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button"
              [class.active]="showHighDustValueUniquesFilters"
              [disabled]="!filter.showHighDustValueUniques"
              (click)="showHighDustValueUniquesFilters = !showHighDustValueUniquesFilters">
              <span class="icon icon-equalizer"></span>
            </button>
          </span>
        </div>

        @if (showHighDustValueUniquesFilters) {
          <div class="filter filter-property filter-padded-left" style="width: 100%;" [class.disabled]="!filter.showHighDustValueUniques">
            <span class="filter-body">
              <span filter-title text="Non-Jewellery">
                When enabled, also highlight Disenchant Weapon and Armour Uniques. <strong>Discount by size</strong> decreases the Dust value of larger items as follows:
                <br />2-slot x 0.9
                <br />3-slot x 0.7
                <br />4-slot x 0.6
                <br />6-slot x 0.4
                <br />8-slot x 0.3
              </span>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn"
                    [disabled]="!filter.showHighDustValueUniques"
                    [class.off]="!filter.showHighDustValueUniquesIncludeNonJewellery"
                    (click)="toggleHighDustValueUniquesIncludeNonJewellery()"></button>
                </span>
                <div class="table-checkbox-label">
                  <span class="filter-title-text">Include</span>
                </div>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!filter.showHighDustValueUniquesIncludeNonJewellery">
                <span class="input-group-btn">
                  <button class="btn toggle-btn"
                    [disabled]="!filter.showHighDustValueUniques || !filter.showHighDustValueUniquesIncludeNonJewellery"
                    [class.off]="!filter.showHighDustValueUniquesDiscountBySize"
                    (click)="toggleHighDustValueUniquesDiscountBySize()"></button>
                </span>
                <div class="table-checkbox-label">
                  <span class="filter-title-text">Discount by size</span>
                </div>
              </div>
            </span>
          </div>
        }
      }
    </div>
    <div class="clear"></div>
  }
</div>

<div class="filter-group" data-group-visibility-id="showRemainingUniquesFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showRemainingUniquesFilters" (click)="filter.groupVisibility.showRemainingUniquesFilters = !filter.groupVisibility.showRemainingUniquesFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Remaining Uniques" [activeRules]="activeSpecialRules.remainingUniqueFilters">
          Any Unique which is not particularly valuable, or has no special properties. You can choose to highlight them, simply show them, or hide them entirely.
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showRemainingUniquesFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showRemainingUniquesFilters">
      @if (poe2) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showSmallUniques">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="!filter.showSmallUniques"
              (click)="toggleHighlightSmallOtherUniques()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Small Disenchant Uniques" [additionalContent]="smallOtherUniquesStylePreview" ruleId="uniques-small">
              <ng-template #smallOtherUniquesStylePreview>
                <app-custom-rule-style-picker
                  [filter]="filter"
                  [active]="filter.showSmallUniques === true"
                  [defaultHidden]="filter.hideAllRemainingUniques"
                  ruleId="uniques-small"
                  [exampleName]="'Iron Ring'"
                  [rarity]="Rarity.Unique"
                  [title]="'Small Disenchant Uniques'"></app-custom-rule-style-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Max Size
            </div>
            <span class="sep"></span>
            <app-select-gear-size
              [allowedSizes]="[GearSizeType.SmallOnly, GearSizeType.TwoByTwoOnly, GearSizeType.JewelleryOnly]"
              [disabled]="!filter.showSmallUniques"
              [(ngModel)]="filter.showSmallUniquesMaxSize"
              (selectedValueChange)="updateFilter()"></app-select-gear-size>
          </span>
        </div>
      }

      <div class="filter filter-property full-span" [class.disabled]="!filter.uniqueTierCosmetics[4].displayOptions.active">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.uniqueTierCosmetics[4].displayOptions.active" (click)="toggleHighlightOtherUniques()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Other Uniques" [additionalContent]="otherUniquesStylePreview" ruleId="uniques-other">
            Enable this rule to Highlight them, disable the rule to simply show them unstyled;
            or hide them when the 'Hide All Remaining Uniques' rule below is enabled.
            <ng-template #otherUniquesStylePreview>
              <app-style-picker
                [displayable]="filter.uniqueTierCosmetics[4]"
                [allowHide]="false"
                [forceHidden]="!filter.uniqueTierCosmetics[4].displayOptions.active && filter.hideAllRemainingUniques"
                [defaultVisible]="!filter.hideAllRemainingUniques"
                [defaultHidden]="filter.hideAllRemainingUniques"
                [exampleName]="firstOtherUnique"
                [rarity]="Rarity.Unique"
                [title]="'Other Uniques'"></app-style-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.hideAllRemainingUniques">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [disabled]="filter.uniqueTierCosmetics[0].displayOptions.active
              && filter.uniqueTierCosmetics[1].displayOptions.active
              && filter.uniqueTierCosmetics[2].displayOptions.active
              && filter.uniqueTierCosmetics[3].displayOptions.active
              && filter.uniqueTierCosmetics[4].displayOptions.active"
            [class.off]="!filter.hideAllRemainingUniques"
            (click)="toggleHideAllRemainingUniques()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide All Remaining Uniques" ruleId="uniques-hide-remaining">
            Enable this to hide all Unique items not matched by any of the above rules (including Valuable Uniques). When disabled, those Unique items will still be shown, just not Highlighted.
            <br /><br />Using the <span class="icon icon-equalizer"></span> Configuration button, you can configure whether to exclude (and thus still show or highlight) specific low-value boss-only uniques.
          </span>
          <span class="sep"></span>
          <button class="btn toggle-button show-filters-button"
            [class.active]="showLowValueBossUniquesFilters"
            [disabled]="!filter.hideAllRemainingUniques"
            (click)="showLowValueBossUniquesFilters = !showLowValueBossUniquesFilters">
            <span class="icon icon-equalizer"></span>
          </button>
        </span>
        @if (filter.uniqueTierCosmetics[0].displayOptions.active
          && filter.uniqueTierCosmetics[1].displayOptions.active
          && filter.uniqueTierCosmetics[2].displayOptions.active
          && filter.uniqueTierCosmetics[3].displayOptions.active
          && filter.uniqueTierCosmetics[4].displayOptions.active) {
          <div class="disabled-filter-property" (click)="navigateToOtherUniques()">
            All Uniques are highlighted, no Remaining Uniques to hide.
          </div>
        }
      </div>

      @if (showLowValueBossUniquesFilters) {
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="Show {{ isMobile() ? '' : 'Low-value ' }} Boss-only uniques">
              When hiding all remaining uniques, choose whether to still show low-value uniques from your selected endgame content, or from all other boss-only low-value uniques.
            </span>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="uniques-favourite-bosses">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="!filter.showFavouriteLowValueBossUniques"
                  (click)="toggleShowFavouriteLowValueBossUniques()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Favourite</span>
              </div>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="uniques-other-bosses">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="!filter.showOtherLowValueBossUniques"
                  (click)="toggleShowOtherLowValueBossUniques()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Other</span>
              </div>
            </div>
          </span>
        </div>
      }
    </div>
    <div class="clear"></div>
  }
</div>

<div class="filter-group" data-group-visibility-id="showChanceBaseFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showChanceBaseFilters" (click)="filter.groupVisibility.showChanceBaseFilters = !filter.groupVisibility.showChanceBaseFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Chance Bases" [activeRules]="activeSpecialRules.chanceBaseFilters">
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showChanceBaseFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showChanceBaseFilters">
      <div class="filter filter-property full-span" [class.disabled]="!filter.chanceBaseTierCosmetics[0].displayOptions.active">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.chanceBaseTierCosmetics[0].displayOptions.active" (click)="toggleHighlightExcellentChanceBases()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Favourite Chance Bases" [additionalContent]="excellentChanceBasesStylePreview" ruleId="chance-bases-searching">
            You can change which Base Types you're currently looking for or which have 'Potential' on the <a href="/tier-list/chance-bases">Chance Base Tier List</a> tab.
            <br /><br /><strong>Favourite</strong>: {{ searchingChanceBaseTypes.length ? searchingChanceBaseTypes.join(', ') : 'None' }}
            <ng-template #excellentChanceBasesStylePreview>
              <app-style-picker
                [allowHide]="false"
                [displayable]="filter.chanceBaseTierCosmetics[0]"
                [exampleName]="firstSearchingChanceBase"
                [rarity]="Rarity.Normal"
                [title]="'Favourite Chance Bases'"></app-style-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" data-filter-rule-id="chance-bases-potential">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [disabled]="!filter.chanceBaseTierCosmetics[0].displayOptions.active"
                [class.off]="!filter.chanceBaseTierCosmetics[1].displayOptions.active" (click)="toggleHighlightGoodChanceBases()"></button>
            </span>
            <div class="table-checkbox-label">
              <span class="filter-title-text">
                Potential Chance Bases
              </span>

              <app-style-picker
                [allowHide]="false"
                [disabled]="!filter.chanceBaseTierCosmetics[0].displayOptions.active"
                [displayable]="filter.chanceBaseTierCosmetics[1]"
                [exampleName]="firstGoodChanceBase"
                [rarity]="Rarity.Normal"
                [title]="'Potential Chance Bases'"></app-style-picker>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
